import { Size } from './types/Size';

export const maintainAspectRatioOf = (
    source: Size,
    target: Size
): Size => {
    return source.height > source.width
        ? applyRatioToWidthOf(target, source)
        : applyRatioToHeightOf(target, source);
};

const applyRatioToWidthOf = (
    target: Size,
    source: Size
): Size => {

    const sourceSizeRatio = source.height / source.width;
    const thumbnailSizeRatio = target.height / target.width;

    return {
        width: target.width * (thumbnailSizeRatio / sourceSizeRatio),
        height: target.height
    };
};

const applyRatioToHeightOf = (
    target: Size,
    source: Size
): Size => {

    const sourceSizeRatio = source.width / source.height;
    const thumbnailSizeRatio = target.width / target.height;

    return {
        width: target.width,
        height: target.height * (thumbnailSizeRatio / sourceSizeRatio)
    };
};